import { render, staticRenderFns } from "./ItemEdit.vue?vue&type=template&id=644ac073"
import script from "./ItemEdit.vue?vue&type=script&lang=js"
export * from "./ItemEdit.vue?vue&type=script&lang=js"
import style0 from "./ItemEdit.vue?vue&type=style&index=0&id=644ac073&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports